import React, { PureComponent, PropTypes } from 'react';
import { NavLink } from 'react-router-dom';
import Media from 'react-media';
import classNames from 'classnames';
import BootstrapDropDown from './BootstrapDropDown';


class CompanyChooser extends PureComponent {
  static propTypes = {
    companies: PropTypes.array.isRequired,
    company: PropTypes.object.isRequired,
    setCompany: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.setCompany = this.setCompany.bind(this);
  }


  setCompany(company) {
    this.props.setCompany(company);
  }

  render() {
    const { company: { id, fullName }, companies } = this.props;
    return (
      <BootstrapDropDown title={fullName}>
        {companies.map(c => 
          <a
            key={c.id}
            href="#"
            onClick={_ => this.setCompany(c)}
            className={classNames('dropdown-item', {active: c.id === id })}
          >
            {c.fullName}
          </a>
        )}
      </BootstrapDropDown>
    );
  }
}

const Navigation = ({ openCart, user, company, cartIsOpen, setCompany }) => (
  <nav id="main-nav" className="navbar fixed-top justify-content-between flex-row desktop-nav">
    <NavLink to="/" className="logo"/>
    <ul className="nav justify-content-center">
      <li className="nav-item">
        <NavLink className="nav-link" activeClassName="active" to="/browse">
          Reklāmas vietas
        </NavLink>
      </li>
      {/*<li className="nav-item">
        <NavLink className="nav-link" activeClassName="active" to="/news">Jaunumi</NavLink>
      </li>*/}
      <li className="nav-item">
        <NavLink className="nav-link" activeClassName="active" to="/gallery">Galerija</NavLink>
      </li>
      <li className="nav-item">
        <NavLink className="nav-link" activeClassName="active" to="/contacts">Kontakti</NavLink>
      </li>
    </ul>
    <nav className="side-nav">
      { user
        ? (<ul className="nav justify-content-center">
            { company && <CompanyChooser
              company={company}
              companies={user.companies}
              setCompany={setCompany}
            />}
            <BootstrapDropDown title="Mans profils">
              <NavLink className="dropdown-item" activeClassName="active" to="/profile/company">
                Uzņēmums
              </NavLink>
              <NavLink className="dropdown-item" activeClassName="active" to="/profile/orders">
                Pasūtījumi
              </NavLink>
              <NavLink className="dropdown-item" activeClassName="active" to="/profile/invoices">
                Rēķini
              </NavLink>
            </BootstrapDropDown>

            <li className="nav-item">
              <a className={classNames('nav-link', {active: cartIsOpen})} onClick={openCart}>
                <i className="fa basket fa-shopping-basket"/>
              </a>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" activeClassName="active" to="/logout">
                {user.firstName} <i className="fa fa-sign-out"/>
              </NavLink>
            </li>
          </ul>)
        : (<ul className="nav justify-content-center">
            <li className="nav-item">
              <NavLink className="nav-link" activeClassName="active" to="/registration">
                Reģistrēties
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" activeClassName="active" to="/login">
                Ieiet <i className="fa fa-sign-in"/>
              </NavLink>
            </li>
          </ul>)
      }
    </nav>
  </nav>
);

const MobileNav = _ => (
  <nav  id="main-nav" className="navbar fixed-top  flex-row mobile-nav">
    <NavLink to="/" className="logo"/>
    <ul className="nav">
      <li className="nav-item">
        <NavLink className="nav-link" activeClassName="active" to="/browse">
          Reklāmas vietas
        </NavLink>
      </li>
      {/*<li className="nav-item">
        <NavLink className="nav-link" activeClassName="active" to="/news">Jaunumi</NavLink>
      </li>*/}
      <li className="nav-item">
        <NavLink className="nav-link" activeClassName="active" to="/gallery">Galerija</NavLink>
      </li>
      <li className="nav-item">
        <NavLink className="nav-link" activeClassName="active" to="/contacts">Kontakti</NavLink>
      </li>
    </ul>
  </nav>
);

Navigation.propTypes = {
  openCart: PropTypes.func.isRequired,
  cartIsOpen: PropTypes.bool.isRequired,
  setCompany: PropTypes.func.isRequired,
  user: PropTypes.object,
  company: PropTypes.object,
};

const WrappedNavigation = props => (
  <Media query={{ maxWidth: 575 }}>
    {matches => matches ? <MobileNav/>: <Navigation {...props} />}
  </Media>
);

export default WrappedNavigation;



// WEBPACK FOOTER //
// ./src/components/Navigation.js